import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const FormNextLink = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='FormNextLink' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M6,12.4 L18,12.4 M12.6,7 L18,12.4 L12.6,17.8' />
  </StyledIcon>
);
